import React from 'react';

export const SocialMedia = () => (
  <div className="social_media">
    <a href="https://www.facebook.com/DefensedesEnfantsBelgique"><i className="fab fa-facebook-f" /></a>
    <a href="https://twitter.com/DEI_Belgique"><i className="fab fa-instagram" /></a>
    <a href="https://www.instagram.com/deibelgique"><i className="fab fa-twitter" /></a>
  </div>
);
